import type { TrendsResponse } from '@pulse/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** Trends by week or month, ending at a period; the current one when none is given (TRN-1 to TRN-5). */
export function useTrends(view: 'week' | 'month', period: string | null) {
  return useQuery({
    queryKey: ['pages', 'trends', view, period ?? ''],
    queryFn: () => apiRequest<TrendsResponse>('/api/pages/trends', { searchParams: { view: view === 'week' ? undefined : view, period: period ?? undefined } }),
    staleTime: 60_000,
  });
}
